import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  topPageBg: {
    height: "450px",
    backgroundImage: `linear-gradient(#282437, #282437, #282437)`,
    color: "#ffffff",
    margin: 0,
    overflow: 'hidden',
  },
  leftContent: {
    display: "flex",
    flexDirection: "column",
    lineHeight: "25px",
    alignItems: "flex-start",
  },
  topContent: {
    padding: "0 6em",
    display: "flex",
    justifyContent: "space-between",
    [theme.breakpoints.down('sm')]:{
      padding: "0 2em",
    }
  },
  hello: {
    backgroundColor: "#0A5FFF",
    color: "#FFFFFF",
    padding: "7px 13px",
    width: "120px",
    borderRadius: "15px",
    borderBottomLeftRadius: 0,
    fontSize: "1.2em",
    fontWeight: 600,
  },
  myName: {
    fontSize: "2.3em",
    fontWeight: 700,
  },
  myStack: {
    fontSize: "1.6em",
    fontWeight: 700,
  },
  socialMessagings: {
    marginTop: "25px",
  },
  email: {
    display: "flex",
    alignItems: "center",
    fontSize: "1em",
    "& .email-icon": {
      marginRight: 5,
      height: "17px",
    },
  },
    socialLinks: {
    display: 'flex',
    marginTop: 20,
  },
  sociaLinkBtn: {
    margin: '0 6px',
    padding: 4,
    '&:hover': {
      transform: 'scale(1.2)',
    }
    },
  socialIcon: {
      width: '20px',
      color: 'rgb(201, 198, 198)',
    },
    promzzyPix: {
      [theme.breakpoints.down('xs')]: {
        display: 'none',
      }
    },
  }));
export { useStyles };
